/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-11-24 17:18:37
 * @LastEditors: Jack Deng
 * @LastEditTime: 2022-05-01 21:53:11
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorButton/Preview/Button/index.tsx
 */
import { scroll } from '@/src/tools/helper';
import React from 'react';
import { useDispatch } from 'react-redux';
import { onCollapseOpen } from '../../slice';
import { ButtonType } from '../../tool';
import styles from './style.less';

function Button({ button }: any) {
  const _d = useDispatch();
  const ref = React.useRef<any>();

  const handleClick = () => {
    const id = button?.uuid;
    scroll(id);
    _d(onCollapseOpen({ idArr: [id] }));
  };

  switch (button?.type) {
    case ButtonType.OUTLINE_FILLED: {
      const regularSyle = {
        padding: `0 ${button?.paddingLeftRight || 0}px`,
        height: `${button?.height || 0}px`,
        borderRadius: `${button?.radius || 0}px`,
        outlineStyle: 'solid',
        outlineWidth: `${button?.outlineStrokeWidth || 0}px`,
        fontFamily: `${button?.regularStyle?.textFont}`,
        fontSize: `${button?.regularStyle?.fontSize}px`,
        fontWeight: button?.regularStyle?.bold ? 700 : 400,
        fontStyle: button?.regularStyle?.italic ? 'italic' : 'normal',
        textDecoration: button?.regularStyle?.underline ? 'underline' : 'unset',
        color: button?.regularStyle?.textColor,
        outlineColor: button?.regularStyle?.outlineColor || 'transparent',
        backgroundColor: button?.regularStyle?.filledColor,
        boxShadow: button?.regularStyle?.enableShadow
          ? `${button?.regularStyle?.shadowStyle?.xoffset}px ${button?.regularStyle?.shadowStyle?.yoffset}px ${button?.regularStyle?.shadowStyle?.blur}px ${button?.regularStyle?.shadowStyle?.spread}px ${button?.regularStyle?.shadowStyle?.shadowColor}`
          : undefined,
      };
      const hoverStyle = {
        padding: `0 ${button?.paddingLeftRight || 0}px`,
        height: `${button?.height || 0}px`,
        borderRadius: `${button?.radius || 0}px`,
        outlineStyle: 'solid',
        outlineWidth: `${button?.outlineStrokeWidth || 0}px`,
        fontFamily: `${button?.hoverStyle?.textFont}`,
        fontSize: `${button?.hoverStyle?.fontSize}px`,
        fontWeight: button?.hoverStyle?.bold ? 700 : 400,
        fontStyle: button?.hoverStyle?.italic ? 'italic' : 'normal',
        textDecoration: button?.hoverStyle?.underline ? 'underline' : 'unset',
        color: button?.hoverStyle?.textColor,
        outlineColor: button?.hoverStyle?.outlineColor || 'transparent',
        backgroundColor: button?.hoverStyle?.filledColor,
        boxShadow: button?.hoverStyle?.enableShadow
          ? `${button?.hoverStyle?.shadowStyle?.xoffset}px ${button?.hoverStyle?.shadowStyle?.yoffset}px ${button?.hoverStyle?.shadowStyle?.blur}px ${button?.hoverStyle?.shadowStyle?.spread}px ${button?.hoverStyle?.shadowStyle?.shadowColor}`
          : undefined,
      };
      return (
        <div
          id={`${button?.uuid}-preview`}
          ref={ref}
          onClick={handleClick}
          className={styles.button}
          onMouseEnter={() => {
            Object.entries(hoverStyle).map(([key, value]) => {
              ref.current.style[key] = value;
            });
          }}
          onMouseLeave={() => {
            Object.entries(regularSyle).map(([key, value]) => {
              ref.current.style[key] = value;
            });
          }}
          style={regularSyle}>
          {button.name}
        </div>
      );
    }
    case ButtonType.TEXT: {
      const regularStyle = {
        fontFamily: `${button?.regularStyle?.textFont}`,
        fontSize: `${button?.regularStyle?.fontSize}px`,
        fontWeight: button?.regularStyle?.bold ? 700 : 400,
        fontStyle: button?.regularStyle?.italic ? 'italic' : 'unset',
        textDecoration: button?.regularStyle?.underline ? 'underline' : 'unset',
        color: button?.regularStyle?.textColor,
      };
      const hoverStyle = {
        fontFamily: `${button?.hoverStyle?.textFont}`,
        fontSize: `${button?.hoverStyle?.fontSize}px`,
        fontWeight: button?.hoverStyle?.bold ? 700 : 400,
        fontStyle: button?.hoverStyle?.italic ? 'italic' : 'unset',
        textDecoration: button?.hoverStyle?.underline ? 'underline' : 'unset',
        color: button?.hoverStyle?.textColor,
      };

      return (
        <div
          id={`${button?.uuid}-preview`}
          ref={ref}
          onClick={handleClick}
          className={styles.button}
          onMouseEnter={() => {
            Object.entries(hoverStyle).map(([key, value]) => {
              ref.current.style[key] = value;
            });
          }}
          onMouseLeave={() => {
            Object.entries(regularStyle).map(([key, value]) => {
              ref.current.style[key] = value;
            });
          }}
          style={regularStyle}>
          {button.name}
        </div>
      );
    }
    default:
      return null;
  }
}

export default Button;
